import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import type { FinanceCalculatorModalType } from "../../../utils/modalConstants";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";

const FinanceCalculatorModal = (props: ModalViewType<FinanceCalculatorModalType>): JSX.Element => {
    const { show, modalSettings } = props;
    const { title, containerID, resetCalculator } = modalSettings;

    const closeLabel = useCommonLabel("close");

    // We don't use props.close since there can also be external events which hide the modal, so the handling is delegated to the resetCalculator function.
    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            onClose={resetCalculator}
            show={show}
            size="lg"
            /* the tor-* classNames are specific for the Finance Calculator injection
            and should not be reused anywhere else, or-* classnames are for billboard/salesman */
            contentClass="tor-modal-content or-modal-content modal-body"
            disableOutsideClick
            focusTrap={false}
        >
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label={title} />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={resetCalculator}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body noSpacing>
                <div id={containerID} style={{ minHeight: "350px" }} />
            </Modal.Body>
        </ModalBaseView>
    );
};

export default FinanceCalculatorModal;
